import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "targets-list" }
const _hoisted_3 = { class: "target-info" }
const _hoisted_4 = { class: "target-name" }
const _hoisted_5 = {
  key: 0,
  class: "target-nickname"
}

import { ref,onMounted,onUnmounted, reactive } from "vue";
import { TelegramClient } from "@/websocket/Client";
import { message } from "ant-design-vue";
import { useStore } from 'vuex';
interface UserInfo {
	   userId:number;	// 用户ID 聊天唯一ID
     phone:string;	// 手机号
     userName:string;	// 用户名
     userNick:string;	// 用户昵称
     isContact:boolean;	// 是否为联系人
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddFriendModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible", "success"],
  setup(__props: any, { emit: __emit }) {

const client = TelegramClient.getInstance();
const store = useStore();
const phoneNumber = ref("");
const targetIdsList = ref<UserInfo[]>([]);

 


// 表单相关
const taskForm = ref<{
  targetIds: string[];
}>({
  targetIds: [],
});

const props = __props;

const emit = __emit;

 

// 发送验证码
const handleSendTelegramSearch = async () => {
    if(phoneNumber.value == "")
    {
      message.error(`发送失败: TG账号不能为空`);
    }
    const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    const result = await client.sendTelegramSearch(
      account,
      name,
      phoneNumber.value
    );
    if(result.message&&result.message.user_info)
    {
      targetIdsList.value.push(result.message.user_info);
    }
    console.log("handleSendTelegramSearch");

};

onMounted(() => {
  //phoneNumber.value = "fda";
  //targetIdsList.value = [{name:"123",nickname:"123"},{name:"121",nickname:"121"}]
  targetIdsList.value = [];
  console.log("AddFriend onMounted");
});

onUnmounted(() => {

  console.log("AddFriend onUnmounted");

});


const handleCancel = () => {
  console.log("handleCancel");
  emit("update:visible", false);
  targetIdsList.value = [];
  phoneNumber.value = "";
};


const handleAddFriend = async() => {
  console.log("handleAddFriend");
  var targetIds =  taskForm.value.targetIds;
  if(targetIds.length == 0)
  {
    message.error(`发送失败:好友不能为空`);
    return
  }
  var chatIds:any[] = [];
  for (let i = 0; i < targetIds.length; i++) {
    const element1 = targetIds[i];
      for (let ii = 0; ii < targetIdsList.value.length; ii++) {
      const element2 = targetIdsList.value[i];
      if(element1 == element2.userName)
      {
        chatIds.push({userId:element2.userId,userNick:element2.userNick});
      }
    }
  }
  
  const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    const result = await client.sendTelegramAddUser(
      account,
      name,
      chatIds[0].userNick,
      chatIds[0].userId,
    );
    if(result.message&&result.message.code == 1)
    {
      message.info(result.message.msg);
      phoneNumber.value = "";
      targetIdsList.value = [];
    }
    else if(result.message)
    {
      message.error(result.message.msg);
    }


};


 

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: "添加好友",
    onCancel: handleCancel,
    onOk: handleAddFriend,
    width: "500px",
    okText: "添加",
    cancelText: "取消"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "TG号码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: phoneNumber.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((phoneNumber).value = $event)),
                  placeholder: "请输入TG账号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: handleSendTelegramSearch
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" 查找 ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_checkbox_group, {
          value: taskForm.value.targetIds,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((taskForm.value.targetIds) = $event)),
          class: "targets-checkbox-group"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targetIdsList.value, (target) => {
              return (_openBlock(), _createBlock(_component_a_checkbox, {
                key: target.userId,
                value: target.userName,
                class: "target-item"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(target.userName), 1),
                    (target.userId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(target.userId) + ") ", 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})